import Chart from 'chart.js/auto';

document.querySelectorAll('textarea._chartdata[data-target][data-type]').forEach(function(item) {
	try {
		const data = JSON.parse(item.value);
		const myChart = new Chart(document.getElementById(item.dataset.target), {
			type: item.dataset.type,
			data: data,
		});
	} catch (e) {
		console.error("Parsing error:", e);
	}
});